import { PassengersValues } from 'pages/avia/purchase-form/model'

import { FormPassengersValues } from 'entities/ticket/models/form-passengers'
import { GENDER } from 'entities/user/module'

import { PassengerBuyTicket } from 'shared/api/BuyTicketModel'
import { TYPE_AGE } from 'shared/constants'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'

const preparePassengerData = (data: PassengersValues, typeAge: TYPE_AGE) => {
  return {
    age: typeAge,
    first_name: data.firstName,
    last_name: data.lastName,
    middle_name: '',
    birthdate: dateFormat(data.dateOfBirth, DATE_FORMAT_LIST.YEAR_FULL_DATE),
    gender: data.gender as GENDER,
    citizenship: data.citizenship,
    document_type: data.passport,
    document_number: data.serialDocuments,
    document_expiration_date: dateFormat(
      data.documentExpirationDate,
      DATE_FORMAT_LIST.YEAR_FULL_DATE,
    ),
  }
}

export const getPurchasePassenger = (data: FormPassengersValues | null) => {
  if (!data) return []

  const passengersDataAdults: PassengerBuyTicket[] = data![
    TYPE_AGE.ADULTS
  ]?.map((item) => preparePassengerData(item, TYPE_AGE.ADULTS))

  const passengersDataChild: PassengerBuyTicket[] =
    data![TYPE_AGE.CHILDREN]?.map((item) =>
      preparePassengerData(item, TYPE_AGE.CHILDREN),
    ) || []

  // const passengersDataInfantWith: PassengerBuyTicket[] =
  //   data![TYPE_AGE.INFANTS_WITH_SEAT]?.map((item) =>
  //     preparePassengerData(item, TYPE_AGE.INFANTS_WITH_SEAT),
  //   ) || []

  const passengersDataInfant: PassengerBuyTicket[] =
    data![TYPE_AGE.INFANTS_WITHOUT_SEAT]?.map((item) =>
      preparePassengerData(item, TYPE_AGE.INFANTS_WITHOUT_SEAT),
    ) || []

  return [
    ...passengersDataAdults,
    ...passengersDataChild,
    // ...passengersDataInfantWith,
    ...passengersDataInfant,
  ]
}
